// eslint-disable-next-line no-unused-vars
import React, { forwardRef } from 'react';
import { bool, node } from 'prop-types';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@emotion/react';

const StyledContainer = styled.div`
  width: 120px;
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  font-size: 0.875em;
  margin: 0 -5px;

  .badge {
    &.isEol {
      color: ${ props => props.theme.colors.white };
      background-color: ${ props => props.theme.products.colors.isEol };
    }

    &.isResealed {
      color: ${ props => props.theme.products.colors.isResealed };
      border-color: ${ props => props.theme.products.colors.isResealed };
    }

    display: flex;
    background-color: ${ props => props.theme.colors.white };
    justify-content: center;
    align-items: center;
    width: 120px;
    min-height: 20px;
    height: auto;
    margin: 2px 0;
    border: 1px solid;
    padding: 2px 5px;
    font-size: 0.875rem;
    text-align: center;
    line-height: 1rem;
  }

  @media screen and (max-width: ${ props => props.theme.device.mobile }) {
    .badge {
      width: 76px;
      font-size: 9px;
    }
  }
`;

const CheckoutBadges = forwardRef((props, ref) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const {
    isResealed = false,
    isClearance = false,
    children
  } = props;

  const renderBadges = () => {
    if (isResealed) {
      return <span className="badge isResealed">{ t('products.isResealed') }</span>;
    }
    return (
      <>
        { isClearance && (
          <span className="badge isEol isClearance">{ t('products.clearance') }</span>
        ) }
      </>
    );
  };

  return (
    <StyledContainer className="badges" theme={ theme } ref={ ref }>
      { renderBadges() }
      { children }
    </StyledContainer>
  );
});

CheckoutBadges.propTypes = {
  children: node,
  isClearance: bool,
  isResealed: bool,
};
CheckoutBadges.displayName = 'CheckoutBadges';

export default CheckoutBadges;
